import { createContext, useContext } from 'react';

type ContextMenuContextData = {
  onCloseMenu: VoidFunction;
};

export const ContextMenuContext = createContext<ContextMenuContextData>({
  onCloseMenu: () => undefined,
});
export const ContextMenuContextProvider = ContextMenuContext.Provider;

export function useContextMenuContext(): ContextMenuContextData {
  const context = useContext(ContextMenuContext);

  if (!context) {
    throw new Error('Can not `useContextMenuContext` outside of the `ContextMenuContextProvider`');
  }

  return context;
}
